module.exports = __webpack_public_path__ + "img/lizi.3ff73ac8.png";